// Shopify Sizing Guide - Vanilla JavaScript Implementation
;(() => {
  // Configuration
  const SIZES = ["S", "M", "L", "XL", "XXL"]
  const MIN_HEIGHT = 60
  const MAX_HEIGHT = 74
  const MIN_WEIGHT = 85
  const MAX_WEIGHT = 240

  // Height ranges and body type mappings
  const HEIGHT_RANGES = [
    { min: 60, max: 62, label: "5'0\"-5'2\"" },
    { min: 63, max: 65, label: "5'3\"-5'5\"" },
    { min: 66, max: 68, label: "5'6\"-5'8\"" },
    { min: 69, max: 71, label: "5'9\"-5'11\"" },
    { min: 72, max: 74, label: "6'0\"-6'2\"" },
  ]

  const WEIGHT_MAPPINGS = {
    "5'0\"-5'2\"": [
      { min: 85, max: 100, bodyType: 1 },
      { min: 100, max: 110, bodyType: 2 },
      { min: 110, max: 125, bodyType: 3 },
      { min: 125, max: 140, bodyType: 4 },
      { min: 140, max: 160, bodyType: 5 },
    ],
    "5'3\"-5'5\"": [
      { min: 95, max: 110, bodyType: 6 },
      { min: 110, max: 120, bodyType: 7 },
      { min: 120, max: 135, bodyType: 8 },
      { min: 135, max: 150, bodyType: 9 },
      { min: 150, max: 170, bodyType: 10 },
    ],
    "5'6\"-5'8\"": [
      { min: 110, max: 125, bodyType: 11 },
      { min: 125, max: 135, bodyType: 12 },
      { min: 135, max: 150, bodyType: 13 },
      { min: 150, max: 165, bodyType: 14 },
      { min: 165, max: 190, bodyType: 15 },
    ],
    "5'9\"-5'11\"": [
      { min: 125, max: 140, bodyType: 16 },
      { min: 140, max: 155, bodyType: 17 },
      { min: 155, max: 170, bodyType: 18 },
      { min: 170, max: 190, bodyType: 19 },
      { min: 190, max: 220, bodyType: 20 },
    ],
    "6'0\"-6'2\"": [
      { min: 135, max: 150, bodyType: 21 },
      { min: 150, max: 165, bodyType: 22 },
      { min: 165, max: 185, bodyType: 23 },
      { min: 185, max: 205, bodyType: 24 },
      { min: 205, max: 240, bodyType: 25 },
    ],
  }

  // Body type to photo mappings
  const BODY_TYPE_TO_PHOTOS = {
    1: { S: 1, M: 2, L: 3, XL: 4, XXL: 5 },
    2: { S: 6, M: 7, L: 8, XL: 9, XXL: 10 },
    3: { S: 11, M: 12, L: 13, XL: 14, XXL: 15 },
    4: { S: 16, M: 17, L: 18, XL: 19, XXL: 20 },
    5: { S: 21, M: 22, L: 23, XL: 24, XXL: 25 },
    6: { S: 26, M: 27, L: 28, XL: 29, XXL: 30 },
    7: { S: 31, M: 32, L: 33, XL: 34, XXL: 35 },
    8: { S: 36, M: 37, L: 38, XL: 39, XXL: 40 },
    9: { S: 41, M: 42, L: 43, XL: 44, XXL: 45 },
    10: { S: 46, M: 47, L: 48, XL: 49, XXL: 50 },
    11: { S: 51, M: 52, L: 53, XL: 54, XXL: 55 },
    12: { S: 56, M: 57, L: 58, XL: 59, XXL: 60 },
    13: { S: 61, M: 62, L: 63, XL: 64, XXL: 65 },
    14: { S: 66, M: 67, L: 68, XL: 69, XXL: 70 },
    15: { S: 71, M: 72, L: 73, XL: 74, XXL: 75 },
    16: { S: 76, M: 77, L: 78, XL: 79, XXL: 80 },
    17: { S: 81, M: 82, L: 83, XL: 84, XXL: 85 },
    18: { S: 86, M: 87, L: 88, XL: 89, XXL: 90 },
    19: { S: 91, M: 92, L: 93, XL: 94, XXL: 95 },
    20: { S: 96, M: 97, L: 98, XL: 99, XXL: 100 },
    21: { S: 101, M: 102, L: 103, XL: 104, XXL: 105 },
    22: { S: 106, M: 107, L: 108, XL: 109, XXL: 110 },
    23: { S: 111, M: 112, L: 113, XL: 114, XXL: 115 },
    24: { S: 116, M: 117, L: 118, XL: 119, XXL: 120 },
    25: { S: 121, M: 122, L: 123, XL: 124, XXL: 125 },
  }

  // Photo URLs
  const FRONT_PHOTOS = {
    1: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/f38fa889-4524-43ff-750e-88606a914b00/Full",
    2: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/10f0cbbe-2b5c-4ada-9fdc-9c185b27e200/Full",
    3: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/d2800012-35fc-449f-1cf7-684aaf0e9c00/Full",
    4: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/14755009-f29a-47e3-cc53-018d998e3000/Full",
    5: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/75cf7c70-de1f-423c-9bbc-0b79fbced000/Full",
    6: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/91074a4b-fedc-467a-fcd1-47b6da41a300/Full",
    7: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/736e65ce-8f84-4fa4-4793-be4005878b00/Full",
    8: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/35c42476-83fd-4a98-fdb1-e2eb3270d900/Full",
    9: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/d7d783d6-46f4-4f7d-a86f-26c10e691a00/Full",
    10: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/30ec8720-0620-49f5-e187-21db1bfbaa00/Full",
    11: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/78234b2f-5432-4561-c2b4-4273ccda4200/Full",
    12: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/e2a9e640-4b8d-4939-7967-61fb3f4e2a00/Full",
    13: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/87a0e186-19ad-45be-6340-a94f07114300/Full",
    14: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/eae1d038-c784-4aab-67e5-09abd4ec1d00/Full",
    15: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/79f9f230-4ecd-42ab-ee57-3a9dea694200/Full",
    16: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/55af53a1-704e-4db6-4cde-5d32ba242200/Full",
    17: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/115edc4c-986b-4917-be3c-c553bf176700/Full",
    18: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/e43bc406-d44c-48a6-c398-ed8fcc967100/Full",
    19: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/329004b4-9baa-4ce3-a0ce-c71975aab500/Full",
    20: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/13001eee-9137-4f96-3f37-3b1194059500/Full",
    21: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/66319337-f0bd-4963-7c62-32f0ede79b00/Full",
    22: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/35b65c59-2035-4e0a-7dee-77f6e388a400/Full",
    23: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/ab790f1d-eb15-4e03-9345-41c454e4ab00/Full",
    24: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/b0ba3f50-19e0-4e07-982e-aeffc73d4f00/Full",
    25: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/16ab91fe-8546-4e6e-873b-d8cf338fea00/Full",
    26: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/4e9c5e85-014a-427d-cb7c-3894a9eec300/Full",
    27: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/7ea044d1-e34c-4eb7-dfdd-82704ab1b100/Full",
    28: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/c5d1a017-f04f-46d7-7f03-947980134400/Full",
    29: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/56625b10-5ea8-4de0-9c13-10fc8a731c00/Full",
    30: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/bca79cc0-3714-4002-0d0e-66ef38256a00/Full",
    31: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/e13873f5-3ba7-4a87-9e40-3b01b0950500/Full",
    32: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/8335da2f-3d8b-493a-0e55-c273b11c1c00/Full",
    33: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/b38cb601-a19e-4181-9131-ba22bfa13e00/Full",
    34: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/b86d3ba2-8e03-4cdc-e230-c41129229a00/Full",
    35: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/b6d0fac7-4dd7-467f-d65c-52e9ee823c00/Full",
    36: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/571bbb4c-b356-44f3-fb0d-465bfff6db00/Full",
    37: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/d54f44cc-dbea-40ef-49dc-24a143cd2b00/Full",
    38: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/16f32604-7a04-4558-60c3-f6a30d29ee00/Full",
    39: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/1fe39a75-e7eb-48a5-d6e9-5b50c2841600/Full",
    40: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/ec265f2d-e2f9-480b-8ddb-8c57f00c0400/Full",
    41: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/cee1e13d-9bcc-4441-ca94-cf88e10cce00/Full",
    42: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/6e972e08-9d46-450d-032d-398a90091e00/Full",
    43: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/e57e5473-fd2c-45fd-95ab-82ea29dc4f00/Full",
    44: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/1ca08ca7-ed88-4f7b-b426-de6d93168b00/Full",
    45: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/26b0b4d9-445d-45dd-4c08-87261620f200/Full",
    46: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/bb1f1920-5fdd-4aeb-66a6-2033c8669d00/Full",
    47: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/ae37efea-ece3-4f58-8fcd-c44ef4d3c700/Full",
    48: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/a924b433-9314-4020-314b-46345c58ec00/Full",
    49: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/f99d3c2d-f63a-4404-0581-8638bd7fda00/Full",
    50: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/ff8046db-fd64-4ea6-fe3b-8fb1671fbb00/Full",
    51: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/40cd8768-bc6c-4149-ba30-c396ebde9700/Full",
    52: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/abed6463-0ef1-4970-a4f1-7b9930bdeb00/Full",
    53: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/910137fb-35e8-4745-b1e0-d1ba09e88700/Full",
    54: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/70bb27f4-e649-4500-18a3-6197ed83fd00/Full",
    55: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/1b66e918-e575-484f-b37e-1fabeb241300/Full",
    56: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/ad48564e-55a3-4f57-c602-03fda5ecd000/Full",
    57: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/e41d65dc-c1a9-4b8f-a694-a2b74b8c1e00/Full",
    58: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/331751a6-1125-43b0-6a98-340e975ba300/Full",
    59: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/d8ed1845-ace4-47b4-237f-5ebbc0302500/Full",
    60: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/ef6d6d3c-64fa-4ede-7d2b-3c68e9586c00/Full",
    61: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/272c7b15-0292-43d8-c85d-abec4c861e00/Full",
    62: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/fd20bca8-c366-4a9b-7309-d98afd923c00/Full",
    63: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/84036045-8cb6-4348-1afb-fa77802e2200/Full",
    64: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/75e2e207-4df2-45a9-4321-94fae4967800/Full",
    65: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/7e36a6d4-4b4b-4de1-9f76-b216e7dfb900/Full",
    66: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/3f41a783-6a7e-4d55-3455-aea5cda1dd00/Full",
    67: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/fdc03499-fc53-4931-574a-6e5483376c00/Full",
    68: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/3c448ee4-2467-4825-8072-25862728e600/Full",
    69: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/6d4985f8-071f-4ccd-7cee-b2e7eb1fa500/Full",
    70: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/8332ce85-e538-4d69-ee1c-8faa785a1700/Full",
    71: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/64046e1b-553b-4821-d2d4-14b81d0b2400/Full",
    72: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/ffb3fe2d-1de8-4d22-c3f6-0b3c85033e00/Full",
    73: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/15456f97-fbda-4085-220e-9facda11c700/Full",
    74: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/75b67a4f-47d4-4f20-01ff-49e32304ad00/Full",
    75: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/4322e12d-3636-4c4e-35b8-fe29fa40aa00/Full",
    76: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/55d68d72-7c52-4dd8-6870-e74cf16f0400/Full",
    77: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/a9b222f6-26dc-4a3a-96c2-37b8717a0c00/Full",
    78: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/77c33dec-5ad7-4472-6e18-bdb44115f900/Full",
    79: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/1f07a49f-d678-4dbc-1730-053a9f36a000/Full",
    80: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/9d3d3a7b-15b9-4596-5275-aaed6df95e00/Full",
    81: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/cb702ba9-625d-4761-55d6-b39646d5f300/Full",
    82: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/53d0a34f-06b1-4e4e-8552-0f710e103800/Full",
    83: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/22348c38-4093-43e1-2c86-8e43abc18000/Full",
    84: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/0536d8ea-8692-41c0-0e57-b09e7e247c00/Full",
    85: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/4148ff84-7eeb-4d51-5ebf-34a06ebf5400/Full",
    86: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/b6fdc352-4950-41f1-1bd2-8eaf0fd8cc00/Full",
    87: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/1f32051f-318d-448a-bf11-8d07d1973200/Full",
    88: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/418ae0a2-0b84-41af-0a08-2118c17aad00/Full",
    89: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/16d17be3-52c3-420c-d02b-cf71b6f5f400/Full",
    90: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/cc0a40f1-9f38-446f-d754-a39db31c1b00/Full",
    91: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/fe192ff2-13a6-4825-def2-abab7a9ca000/Full",
    92: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/366ee732-6b8f-496a-2cfb-130f7a0a4900/Full",
    93: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/8b0dc489-0edd-4799-8d04-7ab9c4400000/Full",
    94: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/48e46048-a0b1-453f-36fd-bc846fc2ce00/Full",
    95: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/430c8cbb-5ede-4994-70ba-c6369a701400/Full",
    96: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/25ed8d0f-b3cb-426e-b1fe-f3091abf3200/Full",
    97: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/7c0c8a61-a2a9-4379-611f-a8bce3797c00/Full",
    98: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/fdd8f1db-970e-4742-5a73-0e0975116700/Full",
    99: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/089327ac-201f-4c2c-cc45-7f9945f53900/Full",
    100: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/b9defd8a-8e1e-4b30-62a8-73efcac11e00/Full",
    101: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/dca08f8c-0818-4d92-0523-a15d165f5500/Full",
    102: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/df1deb56-6110-44d0-e2db-6efc45f96800/Full",
    103: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/63d28932-bbc3-48a2-f64e-1ae1c1cb0e00/Full",
    104: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/17fac5cc-7dc0-41df-2c57-20c445b28d00/Full",
    105: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/90f04d73-821a-42e5-6f41-4cbbc020f500/Full",
    106: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/1fff8fb3-ecb1-40b9-4144-014e1b300900/Full",
    107: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/242c68d2-2990-4a4a-f820-f788ac4f0400/Full",
    108: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/df46d752-988b-45bf-4275-b11000851500/Full",
    109: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/99fec3e8-0ef6-4236-7ec4-87fe5ec9cd00/Full",
    110: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/f840ba6d-0900-4d0a-dea2-c6faa773b400/Full",
    111: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/dc574c39-588f-4dc2-0c77-0b71bb609000/Full",
    112: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/e1b16adb-077b-4e70-40a0-8316fd5e8800/Full",
    113: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/5aea6837-c4eb-47e7-89fa-678429cecb00/Full",
    114: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/e8734c9d-b07f-4e93-ba6f-559b64c39700/Full",
    115: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/7c3430cd-2dd7-41a1-a5fd-218184a26d00/Full",
    116: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/c2882302-ce95-46a5-6599-8a9b8493f300/Full",
    117: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/c37e241d-a8d4-4b76-a887-39bb6e2b6800/Full",
    118: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/fa881f4b-fe86-4b90-b23e-1eb0a5f96b00/Full",
    119: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/3d9c654d-cce6-46be-93db-e888a5628e00/Full",
    120: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/3b73e9b1-c17a-4519-bc6e-b3abc4d36000/Full",
    121: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/a2ac6f1f-1176-45f4-3985-f94aa44fdf00/Full",
    122: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/12a2eece-2b07-42a5-7215-129d2a9b1900/Full",
    123: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/8c1cc866-f878-4743-0073-41ed92e85300/Full",
    124: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/c936cddf-6623-4a02-963a-fcff085a6e00/Full",
    125: "https://imagedelivery.net/Uym0NIcaE_wmmyXhwr0VGg/067f2924-9d60-4611-27de-b75dbe5cbe00/Full",
  }

  const BACK_PHOTOS = {}

  // Utility functions
  function getBodyType(heightInches, weight) {
    const heightRange = HEIGHT_RANGES.find((range) => heightInches >= range.min && heightInches <= range.max)
    if (!heightRange) return 13 // Default

    const weightMappings = WEIGHT_MAPPINGS[heightRange.label]
    const weightRange = weightMappings.find((range) => weight >= range.min && weight < range.max)
    if (!weightRange) {
      return weight < weightMappings[0].min
        ? weightMappings[0].bodyType
        : weightMappings[weightMappings.length - 1].bodyType
    }
    return weightRange.bodyType
  }

  function getHeightRangeLabel(heightInches) {
    const heightRange = HEIGHT_RANGES.find((range) => heightInches >= range.min && heightInches <= range.max)
    return heightRange ? heightRange.label : "Unknown range"
  }

  function getWeightRangeLabel(heightInches, weight) {
    const heightRange = HEIGHT_RANGES.find((range) => heightInches >= range.min && heightInches <= range.max)
    if (!heightRange) return "Unknown range"

    const weightMappings = WEIGHT_MAPPINGS[heightRange.label]
    const weightRange = weightMappings.find((range) => weight >= range.min && weight < range.max)
    if (!weightRange) return "Outside range"
    return weightRange.min + "-" + weightRange.max + " lbs"
  }

  function getPhotoNumber(bodyType, size) {
    const photoMapping = BODY_TYPE_TO_PHOTOS[bodyType]
    if (!photoMapping) return 63 // Default
    return photoMapping[size] || 63
  }

  function getPhotoUrl(photoNumber, view) {
    const photos = view === "front" ? FRONT_PHOTOS : BACK_PHOTOS
    return photos[photoNumber] || photos[1] || ""
  }

  function formatHeight(inches) {
    const feet = Math.floor(inches / 12)
    const remainingInches = inches % 12
    return feet + "'" + remainingInches + '"'
  }

  // Slider functionality
  function createSlider(container, min, max, step, initialValue, onChange) {
    const sliderWrapper = document.createElement("div")
    sliderWrapper.className = "slider-wrapper"

    const sliderTrack = document.createElement("div")
    sliderTrack.className = "slider-track"

    const sliderProgress = document.createElement("div")
    sliderProgress.className = "slider-progress"

    const slider = document.createElement("input")
    slider.type = "range"
    slider.min = min
    slider.max = max
    slider.step = 1
    slider.value = initialValue

    let rafId = null
    let pendingValue = null

    function updateProgress() {
      const value = Number.parseInt(slider.value)
      const progress = ((value - min) / (max - min)) * 100
      sliderProgress.style.width = progress + "%"
      return value
    }

    // Calculate initial progress percentage
    updateProgress()

    sliderWrapper.appendChild(sliderTrack)
    sliderWrapper.appendChild(sliderProgress)
    sliderWrapper.appendChild(slider)
    container.appendChild(sliderWrapper)

    slider.oninput = () => {
      const value = updateProgress()
      pendingValue = value

      // Cancel any pending animation frame
      if (rafId) {
        cancelAnimationFrame(rafId)
      }

      // Schedule update on next animation frame for 60fps smoothness
      rafId = requestAnimationFrame(() => {
        if (pendingValue !== null) {
          onChange(pendingValue)
          pendingValue = null
        }
        rafId = null
      })
    }

    return slider
  }

  // Add to cart functionality
  async function addToCart(selectedSize) {
    try {
      const variantId = await getVariantIdBySize(selectedSize)
      if (!variantId) {
        console.error("No variant found for size:", selectedSize)
        return
      }

      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
        }),
      })

      if (response.ok) {
        window.location.href = "/cart"
      } else {
        console.error("Failed to add to cart:", response.statusText)
      }
    } catch (error) {
      console.error("Error adding to cart:", error)
    }
  }

  async function getVariantIdBySize(size) {
    try {
      const productHandle = window.location.pathname.split("/").pop()
      const response = await fetch("/products/" + productHandle + ".js")
      const product = await response.json()

      const variant = product.variants.find(
        (v) =>
          (v.option1 && v.option1.toUpperCase() === size.toUpperCase()) ||
          (v.option2 && v.option2.toUpperCase() === size.toUpperCase()) ||
          (v.option3 && v.option3.toUpperCase() === size.toUpperCase()),
      )

      return variant ? variant.id.toString() : null
    } catch (error) {
      console.error("Error fetching product variants:", error)
      return null
    }
  }

  // Main sizing guide class
  function SizingGuide(container) {
    this.container = container
    this.heightInches = 70 // Default to 5'10"
    this.weightLbs = 175 // Default to 175 lbs
    this.bodyType = 18 // Default body type
    this.selectedSize = "XL" // Default to XL
    this.currentView = "front" // Default to front view

    this.init()
  }

  SizingGuide.prototype.init = function () {
    this.render()
    this.bindEvents()
    this.updateBodyType()
    this.updatePhoto()
  }

  SizingGuide.prototype.render = function () {
    this.container.innerHTML = `
      <div class="sizing-guide-wrapper">
        <div class="sizing-guide-container">
          <div class="sizing-guide-photo-section">
            <div class="sizing-guide-photo-container">
              <img id="sizing-guide-photo" src="/placeholder.svg" alt="Sizing Guide Photo" class="sizing-guide-photo">
            </div>
          </div>

          <div class="sizing-guide-controls">
            <div class="sizing-guide-sizes">
              ${SIZES.map(
                (size) => `
                <button class="sizing-guide-size-btn ${size === this.selectedSize ? "active" : ""}" data-size="${size}">
                  ${size}
                </button>
              `,
              ).join("")}
            </div>

            <div class="sizing-guide-sliders">
              <div class="sizing-guide-slider-group">
                <label class="sizing-guide-label">
                  Height: <span id="height-display">${this.formatHeight(this.heightInches)}</span>
                </label>
                <div class="sizing-guide-slider-container" id="height-slider-container"></div>
              </div>

              <div class="sizing-guide-slider-group">
                <label class="sizing-guide-label">
                  Weight: <span id="weight-display">${this.weightLbs} lbs</span>
                </label>
                <div class="sizing-guide-slider-container" id="weight-slider-container"></div>
              </div>
            </div>

            <div class="sizing-guide-actions">
              <button id="add-to-cart-btn" class="sizing-guide-btn sizing-guide-btn-primary">
                Add to Cart - ${this.selectedSize}
              </button>
            </div>

            <div class="sizing-guide-info">
              <p><strong>Body Type:</strong> <span id="body-type-display">${this.bodyType}</span></p>
              <p><strong>Height:</strong> <span id="height-range-display">${getHeightRangeLabel(this.heightInches)}</span></p>
              <p><strong>Weight Range:</strong> <span id="weight-range-display">${getWeightRangeLabel(this.heightInches, this.weightLbs)}</span></p>
            </div>
          </div>
        </div>
      </div>
    `

    // Create sliders
    const heightSliderContainer = this.container.querySelector("#height-slider-container")
    const weightSliderContainer = this.container.querySelector("#weight-slider-container")

    this.heightSlider = createSlider(heightSliderContainer, MIN_HEIGHT, MAX_HEIGHT, 1, this.heightInches, (value) =>
      this.updateHeight(value),
    )

    this.weightSlider = createSlider(weightSliderContainer, MIN_WEIGHT, MAX_WEIGHT, 1, this.weightLbs, (value) =>
      this.updateWeight(value),
    )
  }

  SizingGuide.prototype.bindEvents = function () {
    const self = this

    // Size button events
    this.container.querySelectorAll(".sizing-guide-size-btn").forEach((btn) => {
      btn.addEventListener("click", function () {
        self.updateSize(this.dataset.size)
      })
    })

    // Add to cart event
    this.container.querySelector("#add-to-cart-btn").addEventListener("click", () => {
      addToCart(self.selectedSize)
    })
  }

  SizingGuide.prototype.updateHeight = function (height) {
    this.heightInches = height
    this.container.querySelector("#height-display").textContent = this.formatHeight(height)
    this.updateBodyType()
    this.updatePhoto()
    this.updateInfo()
  }

  SizingGuide.prototype.updateWeight = function (weight) {
    this.weightLbs = weight
    this.container.querySelector("#weight-display").textContent = weight + " lbs"
    this.updateBodyType()
    this.updatePhoto()
    this.updateInfo()
  }

  SizingGuide.prototype.updateSize = function (size) {
    this.selectedSize = size

    // Update button states
    this.container.querySelectorAll(".sizing-guide-size-btn").forEach((btn) => {
      btn.classList.toggle("active", btn.dataset.size === size)
    })

    // Update add to cart button
    this.container.querySelector("#add-to-cart-btn").textContent = "Add to Cart - " + size

    this.updatePhoto()
  }

  SizingGuide.prototype.updateBodyType = function () {
    this.bodyType = getBodyType(this.heightInches, this.weightLbs)
  }

  SizingGuide.prototype.updatePhoto = function () {
    const photoNumber = getPhotoNumber(this.bodyType, this.selectedSize)
    const photoUrl = getPhotoUrl(photoNumber, this.currentView)
    const photoElement = this.container.querySelector("#sizing-guide-photo")

    if (photoElement && photoUrl) {
      const img = new Image()
      img.src = photoUrl
      img
        .decode()
        .then(() => {
          photoElement.src = photoUrl
          photoElement.alt = this.currentView + " view - Size " + this.selectedSize
        })
        .catch(() => {
          // Fallback if decode fails
          photoElement.src = photoUrl
          photoElement.alt = this.currentView + " view - Size " + this.selectedSize
        })
    }
  }

  SizingGuide.prototype.updateInfo = function () {
    this.container.querySelector("#body-type-display").textContent = this.bodyType
    this.container.querySelector("#height-range-display").textContent = getHeightRangeLabel(this.heightInches)
    this.container.querySelector("#weight-range-display").textContent = getWeightRangeLabel(
      this.heightInches,
      this.weightLbs,
    )
  }

  SizingGuide.prototype.formatHeight = (inches) => formatHeight(inches)

  // Auto-initialize when DOM is ready
  function initSizingGuides() {
    const containers = document.querySelectorAll(".shopify-sizing-guide")
    containers.forEach((container) => {
      new SizingGuide(container)
    })
  }

  // Initialize on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initSizingGuides)
  } else {
    initSizingGuides()
  }

  // Expose for manual initialization
  window.ShopifySizingGuide = SizingGuide
})()
